import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  type ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZonelessChangeDetection,
  signal,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideTaiga } from '@taiga-ui/core';
import { TUI_RUSSIAN_LANGUAGE } from '@taiga-ui/i18n/languages/russian';
import { TUI_LANGUAGE } from '@taiga-ui/i18n/tokens';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';

import { environment } from '@env';
import { authInterceptor } from '@core/auth/auth.interceptor';
import { AuthService } from '@core/auth/auth.service';
import { timeoutInterceptor } from '@core/auth/timeout.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withFetch(), withInterceptors([timeoutInterceptor, authInterceptor])),
    provideOAuthClient(),
    { provide: OAuthStorage, useFactory: () => localStorage },
    provideAppInitializer(() => {
      registerLocaleData(localeRu);
    }),
    provideAppInitializer(() => inject(AuthService).initialize()),
    provideAnimations(),
    provideTaiga(),
    // Без этого компоненты Taiga (например, календарь) остаются на английском.
    { provide: TUI_LANGUAGE, useValue: signal(TUI_RUSSIAN_LANGUAGE) },
    { provide: LOCALE_ID, useValue: 'ru' },
    { provide: APP_BASE_HREF, useValue: environment.baseHref },
  ],
};
